<template>
  <div class="content-bg">
    <div class="content" style="background: white">
      <div class="row">
        <div class="col-xs-4">
          <div class="swiper-container" id="swiperIndex">
            <div class="swiper-wrapper">
              <!--轮播图质检聚焦 -->
              <div class="home-banner" id="section-focus-pic" style="width: 380px;height: 250px">
                <div class="bd" data-scro="list">
                <div id="container">
                  <swiper :options="swiperOption" ref="mySwiper" style="width: 100%;height: 250px" v-if="testingLength>0">
                      <swiper-slide class="swiper-slide games" v-for="(item,index) in testingList" :key="index">
                      <a
                        @click="toDetails(item.id)"
                        target="_blank"
                      >
                        <img
                          :src="item.contentUrl"
                        />
                        <div class="banner-title" style="margin-left:-20px!important;text-align:center !important;bottom: 10px !important;">
                          <span style="text-align:center !important;margin-left:-20px!important;">{{item.articleTitle}}</span>
                        </div>
                      </a>
                    </swiper-slide>
               
                <div class="swiper-pagination swiper-pagination-white" slot="pagination" style=""></div>
                <div class="swiper-button-prev swiper-button-white" slot="button-prev" style="margin-left: -10px;color:red ！important;"></div>
                <div class="swiper-button-next swiper-button-white" slot="button-next" style="margin-right: 40px;color:red ！important;"></div>
               </swiper> 
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <!--新闻要素 -->
        <div class="col-xs-6">
          <div class="in_01_c">
            <div class="fr">
              <div class="in_01c_t">
                <ul>
                  <li v-for="(item,index) in newsList" :key="index" @mouseover="showNews(index)">
                    <a
                      @mouseover="showNews(index)"
                      href="javascript:;"
                      @click="showNewPage(item.id,newsList[0].id)"
                      :class="index==newsNum?'newsytle':''"
                    >{{item.label}}</a>
                  </li>
                </ul>
              </div>

              <div class="in_01c_c">
                <ul class="news-list" style="display:block;" v-show="index==newsNum" v-for="(item,index) in newsList" :key="index">
                  <li v-for="(childrenItem,childrenIndex) in item.children" :key="childrenIndex">
                    <a
                      @click="toDetails(childrenItem.id)"
                      :title='childrenItem.articleTitle'
                      target="_blank"
                    >
                    
                      <span class="iconfont icon-point"></span>{{childrenItem.shortTitle==null||childrenItem.shortTitle==''?childrenItem.articleTitle:childrenItem.shortTitle}}
                    </a>
                    <span class="tab-time">{{fromMart(childrenItem.gmtCreate)}}</span>
                  </li>
                 
                </ul>
              </div>
            </div>
          </div>
        </div>
         <!--机构简介 -->
        <div class="col-xs-2">
          <div class="index-middle">
            <div class="module-head">
              <span>
                <a
                  
                  class="title title03"
                  @click="showNewPage(32)"
                >机构简介</a>
              </span>
            </div>
            <div class="module-table-outer">
              <div class="Bcontent">
                <p>为粮食和物资储备产品质量安全提供技术保障，承担行业粮食和物资风险监测和评估、标准研究、技术培训及科技推广应用等技术服务工作，承担资质认定范围内产品质量的检验检测、仲裁检验鉴定及相关研究工作。</p>
              </div>
            </div>
          </div>
          <div class="index-middle">
            <div class="module-head">
              <span>
                <a
                  class="title title03"
                >邮寄样品温馨提醒</a>
              </span>
            </div>
            <div class="module-table-outer">
              <div class="download1">
                <ul>
                  <li style="width: 200px" class="point-type04" >
                    <a
                      @click="showDialog(32)"
                      :title="邮寄样品温馨提醒"
                      target="_blank"
                    >邮寄样品温馨提醒</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-10">
          <div class="module-head" style="margin-bottom: 15px">
            <a
              @click="showNewPage(43)"
              class="titletitlej "
              target="_blank"
            >党建专栏</a>
          </div>
          <div class="banner">
            <div class="bd">
              <ul>
                <li class="item" style="left:0;" v-for="(item,index) in partyImgList" :key="index">
                  <a
                    @click="item.isEnjoy==0?toDetails(item.id):''"
                    target="_blank"
                  >
                    <img
                      :src="item.contentUrl"
                    />
                    <div  class="word">
                      <!-- <span>{{item.shortTitle==null||item.shortTitle==''?item.articleTitle:item.shortTitle}}</span> -->
                      {{item.articleTag}}
                    </div>
                  </a>
                </li>
              </ul>
            </div>
            <div class="hd">
              <ul>
                <li v-for="(item,index) in partyImgList" :key="index"></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-xs-2">
          <div class="index-middle">
            <div class="module-head">
              <span>
                <a href class="title title03">办事查询</a>
              </span>
            </div>
            <div class="module-table-outer">
              <a href="http://cswangshang.vasoe.com.cn/" target="_blank">
              <img src="../styles/images/0626baf01cee7b29df62928e66e7679.png" title="点击进入网上委托查询" width="180px;" height="150px"/>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4">
          <div class="module-head" style="background: #3069b8">
            <a  class="title04">
              <img
                src="../styles/images/Customer_icon.png"
              />
              &nbsp;&nbsp;客户服务
            </a>
          </div>
          <div class="leftnav">
            <ul>
              <li>
                <img src="../styles/images/icon1.png"  />
                <a   @click="showNewPage(50)">仪器查询</a>
              </li>
              <li>
                <img src="../styles/images/icon2.png"  />
                <a  @click="showNewPage(48,45)">收费标准</a>
              </li>
              <li>
                <img src="../styles/images/icon3.png"  />
                <a  @click="showNewPage(50)">综合服务</a>
              </li>
              <li>
                <img src="../styles/images/icon4.png"  />
                <!--
                            <a href="http://www.gxljz.com/zxwt/index.jhtml">在线委托</a>
                -->
                <a href="http://cswangshang.vasoe.com.cn/" target="_blank">在线委托</a>
              </li>

              <li>
                <img src="../styles/images/icon5.png"  />
                <a  @click="showNewPage(49,45)">付款方式</a>
              </li>
              <li>
                <img src="../styles/images/icon6.png"  />
                <a @click="toword(53)">互动交流</a>
              </li>
            </ul>
          </div>
        </div>
        <!--通知公告 -->
        <div class="col-xs-6">
          <div class="in_01_c">
            <div class="fr">
              <div class="in_01c_t in_02_t">
                <ul>
                  <li v-for="(item,index) in noticeList" :key="index" @mouseover="showNotice(index)">
                    <a
                      @mouseover="showNotice(index)"
                      @click="showNewPage(item.id,noticeList[0].id)"
                      :class="index==noticeNum?'newsytle':''"
                      class="active"
                    >{{item.label}}</a>
                  </li>
                </ul>
              </div>
              <div class="in_01c_c in_02_c">
                <ul class="news-list" style="display:block;" v-show="index==noticeNum" v-for="(item,index) in noticeList" :key="index">
                  <li v-for="(childrenItem,childrenIndex) in item.children" :key="childrenIndex">
                    <a
                    @click="toDetails(childrenItem.id)"
                      :title="childrenItem.articleTitle"
                      target="_blank"
                    >
                      <span class="iconfont icon-point"></span>{{childrenItem.shortTitle==null||childrenItem.shortTitle==''?childrenItem.articleTitle:childrenItem.shortTitle}}
                    </a>
                    <span class="tab-time">{{fromMart(childrenItem.gmtCreate)}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-2">
          <div class="index-middle">
            <div class="module-head">
              <span>
                <a
                  class="title title03"
                  @click="showNewPage(44)"
                  target="_blank"
                >&nbsp;&nbsp;&nbsp;&nbsp;资料下载</a>
              </span>
              <a
                class="fr"
                @click="showNewPage(44)"
              >+更多</a>
            </div>
            <div class="module-table-outer">
              <div class="download">
                <ul>
                  <li style="width: 200px" class="point-type04"  v-for="(item,index) in dataList" :key="index">
                    <a
                    @click="toDetails(item.id)"
                      :title="item.articleTitle"
                      target="_blank"
                    >{{item.articleTitle}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-4">
          <div class="module-head" style="background: #88c941">
            <a href="#" class="title04">
              <img
                src="../styles/images/phone-icon.png"
                tppabs="http://www.gxljz.com/r/cms/resource/images/phone-icon.png"
              />
              联系方式
            </a>
          </div>
          <div class="leftnav">
            <table>
              <tbody style="box-sizing: border-box;">
                <tr class="firstRow" style="box-sizing: border-box;">
                  <td
                    width="150"
                    style=" text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148);"
                  >业务办理时间：</td>
                </tr>
                <tr style="box-sizing: border-box;">
                  <td
                    width="150"
                    style="text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148); word-break: break-all;"
                  >周一至周五 上午8:30～12:00，下午14:30～17:30</td>
                </tr>
                <tr style="box-sizing: border-box;">
                  <td
                    width="150"
                    style="text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148); word-break: break-all;"
                  >业务电话：0771-4855503</td>
                </tr>
                <tr style="box-sizing: border-box;">
                  <td
                    width="150"
                    style="text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148); word-break: break-all;"
                  >
                    业务传真：0771-4855503、
                    <span style="ext-align:left; color: rgb(148, 148, 148);">0771-4806225</span>
                  </td>
                </tr>
                <tr style="box-sizing: border-box;">
                  <td
                    width="150"
                    style="text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148); word-break: break-all;"
                  >业务邮箱：ljz0771@163.com</td>
                </tr>
                <tr style="box-sizing: border-box;">
                  <td
                    width="150"
                    style="text-align:left; box-sizing: border-box; margin: 0px; padding: 0px 0px 0px 20px; border-width: 0px; border-style: initial; border-color: initial; line-height: 35px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: rgb(148, 148, 148); word-break: break-all;"
                  >
                    <p>地址：广西南宁市江南区壮锦大道10号</p>
                    <p>邮政编码：530031</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <br />
            </p>
          </div>
        </div>
        <div class="col-xs-6">
          <!--党建专栏 -->
          <div class="in_01_c">
            <div class="fr">
              <div class="in_01c_t in_03_t">
                <ul>
                  <li v-for="(item,index) in partyList" :key="index" @mouseover="showParty(index)" >
                    <a
                      @mouseover="showParty(index)"
                       @click="showNewPage(item.id,partyList[0].id)"
                      :class="index==partyNum?'newsytle':''"
                      class="active"
                    >{{item.label}}</a>
                  </li>
                </ul>
              </div>
              <div class="in_01c_c in_03_c">
                <ul class="news-list" style="display:block;" v-show="index==partyNum" v-for="(item,index) in partyList" :key="index">
                  <li v-for="(childrenItem,childrenIndex) in item.children" :key="childrenIndex">
                    <a
                     @click="toDetails(childrenItem.id)"
                      :title='childrenItem.articleTitle'
                      target="_blank"
                    >
                      <span class="iconfont icon-point"></span>{{childrenItem.articleTitle}}
                    </a>
                    <span class="tab-time">{{fromMart(childrenItem.gmtCreate)}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-2">
          <div class="index-middle">
            <div class="module-head">
              <span>
                <a
                  @click="showNewPage(54)"
                  class="title title03"
                  target="_blank"
                >&nbsp;&nbsp;生活小常识</a>
              </span>
              <a
                @click="showNewPage(54)"
                class="fr"
              >+更多</a>
            </div>
            <div class="module-table-outer" style="height: 212px">
              <table>
                <tr v-for="(item,index) in senseList" :key="index">
                  <td class="point-type04 cR" >
                    <a
                      @click="toDetails(item.id)"
                      :title="item.articleTitle"
                      target="_blank"
                    >{{getTitle(item.articleTitle)}}</a>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="link">
        <img src="../styles/images/link-icon.png"  />友情链接
        <div class="btn-group dropup">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            -区市单位-
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/"
                title="自治区粮食和物资储备局"
                target="_blank"
              >自治区粮食和物资储备局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=93  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=93%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=93"
                title="崇左市粮食局"
                target="_blank"
              >崇左市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=92  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=92%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=92"
                title="来宾市粮食局"
                target="_blank"
              >来宾市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=91  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=91%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=91"
                title="河池市粮食局"
                target="_blank"
              >河池市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=90  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=90%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=90"
                title="贺州市粮食局"
                target="_blank"
              >贺州市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=89  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=89%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=89"
                title="百色市粮食局"
                target="_blank"
              >百色市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=88  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=88%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=88"
                title="玉林市粮食局"
                target="_blank"
              >玉林市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=87  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=87%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=87"
                title="贵港市粮食局"
                target="_blank"
              >贵港市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=86  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=86%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=86"
                title="钦州市粮食局"
                target="_blank"
              >钦州市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.fcgls.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.fcgls.gov.cn/%27"
                tppabs="http://www.fcgls.gov.cn/"
                title="防城港市粮食局"
                target="_blank"
              >防城港市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=84  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=84%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=84"
                title="北海市粮食局"
                target="_blank"
              >北海市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=83  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=83%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=83"
                title="梧州市粮食局"
                target="_blank"
              >梧州市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.glslsj.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.glslsj.gov.cn/%27"
                tppabs="http://www.glslsj.gov.cn/"
                title="桂林市粮食局"
                target="_blank"
              >桂林市粮食局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lsj.liuzhou.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lsj.liuzhou.gov.cn/%27"
                tppabs="http://lsj.liuzhou.gov.cn/"
                title="柳州市粮食局"
                target="_blank"
              >柳州市粮食局</a>
            </li>
          </ul>
        </div>
        <div class="btn-group dropup">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            --直属单位--
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu"></ul>
        </div>
        <div class="btn-group dropup">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            --联系单位--
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxxmlm.com/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxxmlm.com/%27"
                tppabs="http://www.gxxmlm.com/"
                title="广西香米网"
                target="_blank"
              >广西香米网</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=137  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=137%27"
                tppabs="http://lshwzcbj.gxzf.gov.cn/index.php?m=content&c=index&a=lists&catid=137"
                title="广西粮食行业协会"
                target="_blank"
              >广西粮食行业协会</a>
            </li>
          </ul>
        </div>
        <div class="btn-group dropup">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            --区内政府网站--
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu">
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxgxw.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxgxw.gov.cn/%27"
                tppabs="http://www.gxgxw.gov.cn/"
                title="自治区工信委"
                target="_blank"
              >自治区工信委</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxfa.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxfa.gov.cn/%27"
                tppabs="http://www.gxfa.gov.cn/"
                title="自治区水产畜牧局"
                target="_blank"
              >自治区水产畜牧局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxfda.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxfda.gov.cn/%27"
                tppabs="http://www.gxfda.gov.cn/"
                title="自治区食品药品监督管理局"
                target="_blank"
              >自治区食品药品监督管理局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxajj.com/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxajj.com/%27"
                tppabs="http://www.gxajj.com/"
                title="自治区安全生产监督管理局"
                target="_blank"
              >自治区安全生产监督管理局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxqts.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxqts.gov.cn/%27"
                tppabs="http://www.gxqts.gov.cn/"
                title="自治区质量技术监督局"
                target="_blank"
              >自治区质量技术监督局</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxdrc.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxdrc.gov.cn/%27"
                tppabs="http://www.gxdrc.gov.cn/"
                title="自治区林业厅"
                target="_blank"
              >自治区林业厅</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxdrc.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxdrc.gov.cn/%27"
                tppabs="http://www.gxdrc.gov.cn/"
                title="自治区发展和改革委员会"
                target="_blank"
              >自治区发展和改革委员会</a>
            </li>
            <li>
              <a
                href="javascript:if(confirm(%27http://www.gxzf.gov.cn/  \n\nThis file was not retrieved by Teleport Pro, because it is addressed on a domain or path outside the boundaries set for its Starting Address.  \n\nDo you want to open it from the server?%27))window.location=%27http://www.gxzf.gov.cn/%27"
                tppabs="http://www.gxzf.gov.cn/"
                title="自治区人民政府门户网站"
                target="_blank"
              >自治区人民政府门户网站</a>
            </li>
          </ul>
        </div>
        <div class="btn-group dropup" style="display: none">
          <button
            type="button"
            class="btn btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            --行业网站--
            <span class="caret"></span>
          </button>
          <ul class="dropdown-menu"></ul>
          <!--</div>-->
        </div>
      </div>
      <!--<div class="nav-title"><img src="/r/cms/resource/images/weixin.png"></div>-->
    </div>
    <div class="imgApk">
       <img width="80" height="80"  src="../styles/images/apkcode123.png" />
       <div>抽样APP1.0下载</div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="600px">
      <div class="youji">
        <h1 class="h1">邮寄样品温馨提醒</h1>
        <p class="p1">各相关单位:</p>
        <p class="p2">&emsp; &emsp;为防止快递物流公司遗漏样品，请邮寄样品到我中心检测
       的单位，寄样后注意查看物流信息，并及时与我中心业务部(电
        话: 0771-4855503) 联系确认到样情况: 对未经确认的样品,
        本中心对收样不负责任，感谢大家理解及配合!</p>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button type="primary" class="button-footer" @click="dialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { getNews,getColumnByTesting,getNotice,getData,getParty,getSense,getPartyImg } from "@/api/content/column";
export default {
  name: "GwIndex",
  data() {
    return {
      testingList:null,
      newsList:null,
      noticeList:null,
      dataList:null,
      dataList1:null,
      partyList:null,
      senseList:null,
      partyImgList:null,
      dialogVisible:false,
      testingLength:0,
      newsNum:0,
      noticeNum:0,
      partyNum:0,
      swiperOption: {
        autoplay: {
          disableOnInteraction: false, //用户操作后是否禁止自动循环
          delay: 3000 //自自动循环时间
        }, //可选选项，自动滑动
        speed: 2000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
        loop: true, //循环切换
        grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状 // setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
        scrollbar: ".swiper-scrollbar",
        mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
        observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
        pagination: {
          el: ".swiper-pagination", // type : 'progressbar', //分页器形状
          clickable: true //点击分页器的指示点分页器会控制Swiper切换
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      computed: {
        swiper() {
          return this.$refs.mySwiper.swiper;
        }
      }
    };
  },
  created(){
    this.getNew();
    this.getColumnByTestings();
    this.getNotices();
    this.getDatas();
    this.getPartys();
    this.getSenses();
    this.getPartyImgs();
  },
  methods:{
    fromMart(date) {
      if (date) {
        let newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(date);
        console.log(newDate);
        const strAry = newDate[0];
        return strAry;
      } else {
        return "";
      }
    },
    //查询新闻推荐数据
    getNew(){
        getNews().then(response=>{
          this.newsList = response.rows;
          console.log(this.newsList)
        })
    },
    //查询党建专栏数据
    getPartys(){
        getParty().then(response=>{
          this.partyList = response.rows;
        })
    },
    //查询轮播图数据，轮播图数据来源于质检聚焦推荐图文
    getColumnByTestings(){
      getColumnByTesting().then(response=>{
          this.testingList = response.rows;
          this.testingLength=this.testingList.length;
        })
    },
    //查询生活小常识
    getSenses(){
      getSense().then(response=>{
          this.senseList = response.rows;
        })
    },
    //查询通知公告
    getNotices(){
      getNotice().then(response=>{
          this.noticeList = response.rows;
        })
    },
    //查询建党专栏图文推荐数据。按推荐等级和时间获取第一条数据
    getPartyImgs(){
      getPartyImg().then(response=>{
          this.partyImgList = response.rows;
          console.log(this.partyImgList);
        })
    },
    //跳转栏目页面
    showNewPage(id,pid){
      this.$root.num=id;
      if(pid!=null){
        this.$root.num=pid;
      }
      
      this.$router.push({path:'/Aitrcle',query:{id:id,pid:pid}})
    },
    toword(index){
      this.$root.num=index;
      this.$router.push({path:'/leaveWord',query:{id:index}})
    },
    //获取资料下载数据
    getDatas(){
      getData().then(response=>{
          this.dataList = response.rows;
          this.dataList1[0]=this.dataList[0];
          this.dataList1[1]=this.dataList[1];
        })
    },
    //处理数据过长
    getTitle(str){
      if(str.length>10){
        return str.substring(0,10)+"...";
      }
      return str
    },
    //匹配样式
    showNews(index){
      this.newsNum=index;
    },
    showDialog(){
      this.dialogVisible=true;
    },
    //匹配样式
    showNotice(index){
      this.noticeNum=index;
    },
    //匹配样式
    showParty(index){
      this.partyNum=index;
    },
    //跳转详情页面
    toDetails(id){
      this.$router.push({path:'/Aitrcle/Details',query:{id:id}})
    }

   
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../styles/home.css';
@import '../styles/pages.css';
@import '../styles/style.css';
  .row {
        margin-left: 0;
        margin-right: 0;
        margin-top: 15px;
    }

    .col-xs-4, .col-xs-6, .col-xs-2, .col-xs-10 {
        padding-left: 0;
    }

    .col-xs-2 {
        padding-right: 0;
    }
    .newsytle{
      color:red
      
    }
   .download>ul>li{
     text-align: left;
   }
   .download1>ul>li{
     text-align: left;
   }
   .imgApk{
     position: fixed;
     top: 350px;
     right: 10px;
   }
   .word{
     color:#FFFF00;
     /* color:red; */
     float:left;z-index:15;
     position:absolute;
     left:160px;top:40px;
     font-size:35px;
     font-weight:700;
   }
   .youji>.h1{
     font-size: 30px;
   }
   .youji>.p1{
     font-size: 20px;
     text-align: left;
     padding-top: 30px;
   }
   .youji>.p2{
     line-height: 40px;
     font-size: 20px;
     text-align: left;
   }
   .button-footer{
     height: 30px;
     width: 50px;
   }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue